export const DATA_TEST_IDS = {
  STREAM_EMPTY_STATE: 'point_stream_empty_state',
  STREAM_UNBIND_TRIGGER: 'point_stream_unbind_trigger',
  STREAM_UNBIND_MODAL: 'point_stream_unbind_modal',
  STREAM_UNBIND_CONFIRM: 'point_stream_unbind_confirm',
  STREAM_UNBIND_CANCEL: 'point_stream_unbind_cancel',
  STREAM_UNBIND_UNSUPPORTED_PLAYER_WARNING: 'point_stream_unbind_unsupported_player_warning',
};
